import createClient from 'openapi-fetch'
import { withErrorCapture } from 'utils/general/observability/withErrorCapture'
import { ServiceUrls } from 'utils/general/serviceUrls'
import type { paths } from './formTemplatesGeneratedTypes'
import type { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'

interface Params {
  authorization: string
}

export class FormTemplatesHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.FORM_TEMPLATES,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type FormTemplateResponse<Path extends keyof paths, Method extends keyof paths[Path]> = GenericResponse<
  paths,
  Path,
  Method
>
export type FormTemplate = NonNullable<FormTemplateResponse<'/{id}', 'get'>['data']>
export type FormType = FormTemplate['type']
export type FormTemplateRequestBody<Path extends keyof paths, Method extends keyof paths[Path]> = GenericRequestBody<
  paths,
  Path,
  Method
>
